export const csairHome = process.env.VUE_APP_LOGIN;

export const upgradesList = `${process.env.VUE_APP_APP}upgrades/#/list`;

export const upgradesDetails = `${process.env.VUE_APP_APP}upgrades/#/details`;

export const msiteDetails = `${process.env.VUE_APP_APP}msite/#/details`;

export const msiteList = `${process.env.VUE_APP_APP}ticketRefund/#/ticket/updateDetail`;

export const uniteLogin = `${process.env.VUE_APP_LOGIN}touch/com.csair.mbp.index/index.html#com.csair.mbp.login/login?t=forward&redirect=&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=0&coopAccount=`;

export const readnameUrl = `${process.env.VUE_APP_LOGIN}touch/com.csair.mbp.index/index.html#com.csair.mbp.certification/certification?t=forward&redirect=http%3A%2F%2Fettest.csair.com%2FticketRefund%2F%23%2Fticket%2FupdateDetail%3Fidentification%3DY%26realName%3Dtrue%26`;
